export default __webpack_public_path__ + "static/media/slide14.c13b9ef4.jpg";